import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IInfluencerSsoState} from './influencer-sso.state';

const selectInfluencerSso = createFeatureSelector<IInfluencerSsoState>('influencerSso');

export const getInfluencerSsoSuccess = createSelector(
  selectInfluencerSso,
  (state) => state.success
);
export const getInfluencerSsoError = createSelector(
  selectInfluencerSso,
  (state) => state.error
);
export const getPaginatedInfluencerSso = createSelector(
  selectInfluencerSso,
  (state) => state.paginatedInfluencerSso
);
